import { useEffect } from 'react';
import StockleyAvatar from '../../../assets/stockleyAvatar.webp';
import ThomasAvatar from '../../../assets/thomasAvatar.webp';
import YatesAvatar from '../../../assets/yatesAvatar.webp';
import { useAnalytics } from '../../../utils/analytics';
import { BaseStepV2 } from '../../common/v2/BaseStepV2';
import { BaseStepPropsV2 } from '../../common/v2/BaseStepV2.types';
import { StepV2MainContent } from '../../common/v2/StepV2MainContent';
import { MainButtonVariant } from '../../styledComponent/Buttons.style';
import { SuggestedGuide } from './SuggestedGuide';
import {
  SuggestedGuidesContentWrapper,
  SuggestedGuidesDescription,
  SuggestedGuidesLabel,
  SuggestedGuidesList,
} from './SuggestedGuidesStep.style';

interface SuggestedGuidesStepProps extends BaseStepPropsV2 {
  label?: string;
}

export const SuggestedGuidesStep: React.FC<SuggestedGuidesStepProps> = (props) => {
  const { nextStep, description, label, isActive } = props;
  const analytics = useAnalytics();

  useEffect(() => {
    if (isActive) {
      analytics.track(`view suggested guides`);
      return window.scrollTo(0, 0);
    }
  }, [analytics, isActive]);

  const handleCtaClick = () => {
    nextStep();
  };

  return (
    <BaseStepV2 {...props}>
      <StepV2MainContent
        {...props}
        isButtonDisabled={false}
        isLoading={false}
        onButtonClick={handleCtaClick}
        buttonVariant={MainButtonVariant.Black}
        title={undefined}
        description={undefined}
      >
        <SuggestedGuidesContentWrapper>
          {label && <SuggestedGuidesLabel>{label}</SuggestedGuidesLabel>}
          {description && <SuggestedGuidesDescription>{description}</SuggestedGuidesDescription>}
          <SuggestedGuidesList>
            <SuggestedGuide image={StockleyAvatar} name="LeAnzar Stockley" />
            <SuggestedGuide image={YatesAvatar} name="Jacqui Yates" />
            <SuggestedGuide image={ThomasAvatar} name="Dr. Tracey Thomas" />
          </SuggestedGuidesList>
        </SuggestedGuidesContentWrapper>
      </StepV2MainContent>
    </BaseStepV2>
  );
};
